import React from 'react'
import logo from "../assets/new-logo-2.webp"
import { Link } from 'react-router-dom'
import { GrMenu } from "react-icons/gr"
import { useSelector, useDispatch } from "react-redux";
import { addItem } from '../reducers/ToggleAction';
import { useNavigate } from 'react-router-dom';


const Navbar = () => {

  const location = window.location.pathname

  const navigate = useNavigate()

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const abc = state.numOfItems%2

  return (
    <div className='nav-div'>
      <div>
        <img src={logo} id='logo-img' 
        style={{cursor:"pointer"}}
        onClick={()=> navigate('/')}
        alt='vwrap'
        />
      </div>

      <div id='nav-comp'>

        <span id={location == "/" ? "nav-true":""}><Link to={"/"}>Home</Link></span>

        <span id={location == "/about" ? "nav-true":""}><Link to={"/about"}>About</Link></span>

        <span id={location == "/services" ? "nav-true":""}><Link to={"/services"}>Services</Link></span>

        <span id={location == "/client" ? "nav-true":""}><Link to={"/client"}>Clients</Link></span>

        <span id={location == "/project" ? "nav-true":""}><Link to={"/project"}>Projects</Link></span>

        <span id={location == "/massage" ? "nav-true":""}><Link to={"/massage"}>CEO message</Link></span>


      <div className='ml-16'>
      <Link to="/contact">
      <div id='nav-btn'>
        Let's Talk
      </div>
      </Link>
      </div>
      
      </div>
   

      <div id='toggle'>
      <div id='nav-toggle' style={abc == true ? {display:"none"} : {display:"block",cursor:"pointer"}} onClick={() => {
          dispatch(addItem());
        }}>
        <GrMenu size={30} />
      </div>
      </div>


    </div>
  )
}

export default Navbar
